import { render } from "./Gallery.vue?vue&type=template&id=ed29fdd8&scoped=true"
import script from "./Gallery.vue?vue&type=script&lang=js"
export * from "./Gallery.vue?vue&type=script&lang=js"

import "./Gallery.vue?vue&type=style&index=0&id=ed29fdd8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-ed29fdd8"

export default script